import { Store } from '../types/location.types';

export const DEMO_STORE_ID = 27;
export const DEMO_STORE_SLUG = 'test-store';

const DEMO_SESSION_KEY = 'demo_mode_active';

export const isDemoStore = (store: Store | null): boolean => {
  if (!store) return false;
  return store.id === DEMO_STORE_ID;
};

/**
 * Activate demo mode for the current session.
 * Called when a user enters via /test-store.
 */
export const activateDemoMode = (): void => {
  sessionStorage.setItem(DEMO_SESSION_KEY, 'true');
};

/**
 * Deactivate demo mode.
 * Called when the user navigates to a non-demo store URL.
 */
export const deactivateDemoMode = (): void => {
  sessionStorage.removeItem(DEMO_SESSION_KEY);
};

/**
 * Check if demo mode is active.
 * Uses sessionStorage so it persists across page navigations
 * but clears when the browser tab is closed.
 */
export const isDemoModeActive = (): boolean => {
  return sessionStorage.getItem(DEMO_SESSION_KEY) === 'true';
};

/**
 * Check if demo mode is active by reading selectedStore from localStorage
 * OR the session flag. Use this in components outside the DemoModeProvider.
 */
export const isDemoModeFromStorage = (): boolean => {
  // Check session flag first (sticky demo mode)
  if (isDemoModeActive()) return true;
  try {
    const stored = localStorage.getItem('selectedStore');
    if (stored) {
      const store = JSON.parse(stored);
      return store?.id === DEMO_STORE_ID;
    }
  } catch {}
  return false;
};
